export interface AccessoryRange {
  fromDate: string; // dd-MM-yyyy
  fromHour: string; // HH:mm
  toDate: string;
  toHour: string;
}

export interface BusyAccessorySlot {
  plate: string;
  fromDate: string;
  fromHour: string;
  toDate: string;
  toHour: string;
}

export interface AccessoryLike {
  plate: string;
  name: string;
  price?: number;
  deposit?: number;
}

const parseDateTime = (d: string, h: string) => {
  const [day, month, year] = d.split('-').map(Number);
  const [hour, minute] = h.split(':').map(Number);
  return new Date(year, month - 1, day, hour, minute, 0, 0);
};

const rangesOverlap = (aStart: Date, aEnd: Date, bStart: Date, bEnd: Date) =>
  aStart < bEnd && bStart < aEnd;

export const getAvailableAccessories = <T extends AccessoryLike>(
  all: T[],
  busyAccessories: BusyAccessorySlot[],
  desired: AccessoryRange
): T[] => {
  if (!desired.fromDate || !desired.toDate || !desired.fromHour || !desired.toHour) return all;

  const wantStart = parseDateTime(desired.fromDate, desired.fromHour);
  const wantEnd = parseDateTime(desired.toDate, desired.toHour);

  return all.filter(acc => {
    const conflicts = busyAccessories.filter(b => b.plate === acc.plate);
    for (const c of conflicts) {
      const cStart = parseDateTime(c.fromDate, c.fromHour);
      const cEnd = parseDateTime(c.toDate, c.toHour);
      if (rangesOverlap(wantStart, wantEnd, cStart, cEnd)) return false;
    }
    return true;
  });
};

export const getAccessoriesTotalPrice = (plates: string[], all: { plate: string; price: number }[]) =>
  plates.reduce((sum, p) => {
    const acc = all.find(a => a.plate === p);
    return sum + (acc?.price || 0);
  }, 0);